import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { EditionBenefitsRelayProps, VariantId } from '../../types';
import { getHamsKey } from '../../utils/getHamsKey';

import premiumBenefitsModalQueryParameters from './__generated__/premiumBenefitsModalQuery.graphql';
import type {
	PremiumBenefitsModalEntryPointProps,
	PremiumBenefitsModalEntryPointQueries,
} from './premium-benefits-modal';

type EntryPointParams = Pick<EditionBenefitsRelayProps<VariantId>, 'cloudId' | 'product'>;

export const premiumEditionBenefitsModalEntryPoint: EntryPoint<
	EntryPointComponent<
		PremiumBenefitsModalEntryPointQueries,
		PremiumBenefitsModalEntryPointProps['entryPoints'],
		PremiumBenefitsModalEntryPointProps['props'],
		PremiumBenefitsModalEntryPointProps['extraProps']
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-benefits-modal-premium-benefits-modal" */ './premium-benefits-modal'
			).then((mod) => mod.PremiumBenefitsModal),
		{
			moduleId: 'edition-benefits-modal-premium-benefits-modal',
		},
	),
	getPreloadProps: ({ cloudId, product }: EntryPointParams) => ({
		queries: {
			premiumBenefitsModalQuery: {
				parameters: premiumBenefitsModalQueryParameters,
				variables: {
					cloudId,
					hamsProductKey: getHamsKey(product),
				},
			},
		},
		extraProps: {
			product,
		},
	}),
});
